module.exports = __webpack_public_path__ + "media/images/talent/case2-icon02-f38906845f354baa060a7720d76d79a1.png";